import { Injectable } from '@angular/core';
import * as joint from '@clientio/rappid';

import { EmptyPaper } from './paper/EmptyPaper';

/**
 * This FlowchartScrollerService is responsible for serving the scroller.
 * Used per FlowchartComponent (not on root).
 * The scroller can either be the real scroller after init or the empty scroller before init
 * @param paper
 */
@Injectable()
export class FlowchartScrollerService {
  public flowchartId: string;
  private flowchartScroller: joint.ui.PaperScroller;

  public init(flowchartId: string, scroller: joint.ui.PaperScroller) {
    this.flowchartId = flowchartId;
    this.flowchartScroller = scroller;
  }

  /**
   * Returns a Scroller based on BaseScroller according to current state of the service
   * The Proxy Object decides to return the correct BaseScroller.
   */
  public getScroller(): joint.ui.PaperScroller {
    const handler: ProxyHandler<any> = {
      get: (target: any, prop: string | symbol, receiver: any) => {
        const user = this.flowchartScroller ? this.flowchartScroller : new EmptyPaper();
        return Reflect.get(user, prop, receiver);
      },
    };

    return new Proxy({}, handler) as joint.ui.PaperScroller;
  }
}
